import { render, staticRenderFns } from "./AIModelField.vue?vue&type=template&id=51d9c79f&scoped=true&"
import script from "./ai-model-field.js?vue&type=script&lang=js&"
export * from "./ai-model-field.js?vue&type=script&lang=js&"
import style0 from "./AIModelField.vue?vue&type=style&index=0&id=51d9c79f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9c79f",
  null
  
)

export default component.exports